import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.scss']
})
export class ProgressbarComponent implements OnInit {
  private _value;
  @Input() set value(val) {
    this._value = val;
  }
  get value() {
    const roundedValue = Math.round(this._value * 100) / 100;
    return roundedValue > 100 ? 100 : roundedValue;
  }

  @Input() color = 'blue';

  constructor() {}

  ngOnInit() {}
}
